import React from "react";
import { Lock, Check, GraduationCap } from "lucide-react";

const COLORS = { beginner: "#4ADE80", intermediate: "#5CC8FF", advance: "#EC4899", focus: "#D4AF37" };

export default function MilestoneTracker({ data }) {
  if (!data) return null;
  const { steps = [], current_label } = data;
  return (
    <div data-testid="milestone-tracker" className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="font-display text-lg font-semibold flex items-center gap-2">
          <GraduationCap size={18} className="text-[#D4AF37]" /> Dance level
        </p>
        <span data-testid="milestone-current" className="text-[10px] uppercase tracking-wide font-bold text-black bg-[#D4AF37] rounded-full px-2.5 py-1">{current_label}</span>
      </div>
      <div className="space-y-2.5">
        {steps.map((s) => {
          const color = COLORS[s.key] || "#9D4EDD";
          const isFocus = s.key === "focus";
          const attended = isFocus ? s.terms_done : Math.min(s.attended, s.target);
          const target = isFocus ? s.terms_total : s.target;
          const pct = target ? Math.min(100, Math.round((attended / target) * 100)) : 0;
          return (
            <div key={s.key} data-testid={`milestone-step-${s.key}`} className={`rounded-xl border px-3 py-2.5 ${s.unlocked ? "border-white/10 bg-white/5" : "border-white/5 bg-white/[0.02] opacity-70"}`}>
              <div className="flex items-center justify-between text-sm">
                <span className="flex items-center gap-2 font-medium">
                  {!s.unlocked ? <Lock size={13} className="text-[#A19DB0]" /> : s.complete ? <Check size={14} style={{ color }} /> : <span className="w-2 h-2 rounded-full" style={{ background: color }} />}
                  {s.label}
                </span>
                <span className="text-xs text-[#A19DB0]">{isFocus ? `Term ${s.terms_done}/${s.terms_total}` : `${Math.min(s.attended, s.target)}/${s.target} classes`}</span>
              </div>
              {s.unlocked && !s.complete && (
                <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden">
                  <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, background: color }} />
                </div>
              )}
              {!s.unlocked && <p className="text-[#A19DB0]/70 text-[11px] mt-1">Complete the previous level to unlock.</p>}
              {isFocus && s.unlocked && !s.complete && <p className="text-[#A19DB0]/70 text-[11px] mt-1">{s.term_progress}/{s.classes_per_term} classes toward next term</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
